require('./bootstrap');
require('jquery-validation');
require('jquery-validation/dist/additional-methods');
require('./hidden-vars');
